"use client";
// import dynamic from "next/dynamic";
// const ProductHeaderDetail = dynamic(() => import("./product-header-detail"), { ssr: false });
import ProductHeaderDetail from "./product-header-detail";
import ProductImageGallery from "./product-image-gallery";
import { MSProductWithFullDetail, MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import { useSearchParams } from "next/navigation";
import { iconpath } from "@/util/staticresourcespath";
import React, { useEffect, useState } from "react";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import useIsMobile from "../useIsMobile";
import ProductHeaderDetailLoader from "./product-header-detail-loader";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

const ProductHeaderInfo = ({
    allVariantProduct,
    promotionVariantProduct,
    level,
    text,
    loc,
    productContactForm,
    priorityContent,
    enableCompareButton = false,
}: {
    allVariantProduct: MSProductWithFullDetailWithVaraintPreset & { shopCurrency: string };
    promotionVariantProduct?: MSProductWithFullDetail;
    level: string;
    text: { [key: string]: string };
    loc: string;
    productContactForm: JSX.Element | null;
    priorityContent?: boolean;
    enableCompareButton?: boolean;
}) => {
    const disableImage = allVariantProduct.productVariant
        .filter((v) => !v.enableInFrontEnd && v.featuredImageUrl !== allVariantProduct.featuredImageUrl)
        .map((v) => v.featuredImageUrl);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const product: MSProductWithFullDetailWithVaraintPreset & { shopCurrency: string } = {
        ...allVariantProduct,
        productVariant: allVariantProduct.productVariant.filter((v) => v.enableInFrontEnd),
        imagesUrl: allVariantProduct.imagesUrl.filter((url) => !disableImage.includes(url)),
    };
    const formatter = new Intl.NumberFormat("th", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });

    const searchParams = useSearchParams();
    const startVariant = searchParams.get("variant");
    const startIndex = startVariant ? product.productVariant.findIndex((variant) => variant.id === startVariant) : 0;
    const [startImageUrl, setStartImageUrl] = useState(
        product.productVariant.length > 0
            ? product.productVariant[startIndex].featuredImageUrl
            : product.featuredImageUrl,
    );
    const [imageAlt, setImageAlt] = useState(
        product.imagesAlt.length > 0 ? product.imagesAlt[startIndex] : `product-${product.id}`,
    );
    const [weight, setWeight] = useState(
        product.productVariant.length > 0 ? product.productVariant[startIndex].weight : 0,
    );
    const weightFormat = formatter.format(weight ?? 0);

    const handleOnSelectedVariant = (index: number) => {
        const image = product.productVariant[index].featuredImageUrl;
        setStartImageUrl(image);
        const weight = product.productVariant[index].weight;
        setWeight(weight);
        const imageAlt = product.imagesAlt[index] || `product-${product.id}`;
        setImageAlt(imageAlt);
    };
    const closeModal = () => {
        setSelectedImage(null);
    };
    const { hasMouseMoved } = useMouseMovement();
    const colorStyle = useContext(ColorStyleContext);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <ProductImageGallery
                imagesUrl={product.imagesUrl}
                imagesAlt={product.imagesAlt}
                imageAlt={imageAlt}
                currentImageUrl={startImageUrl}
                setSelectedImage={setSelectedImage}></ProductImageGallery>
            <div className="w-full px-4 md:px-0">
                <ProductHeaderDetailLoader
                    product={product}
                    promotionVariantProduct={promotionVariantProduct}
                    startVariantId={startVariant}
                    onSelectedVariantIndex={handleOnSelectedVariant}
                    level={level}
                    text={text}
                    loc={loc}
                    productContactForm={productContactForm}
                    priorityContent={priorityContent}
                    enableCompareButton={enableCompareButton}
                />
            </div>
            {hasMouseMoved && (
                <>
                    {selectedImage && (
                        <div
                            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
                            style={{ zIndex: 9999 }}
                            onClick={closeModal}>
                            <div className="relative bg-white p-4 rounded-lg" onClick={(e) => e.stopPropagation()}>
                                <button className="absolute top-2 right-2 text-xl font-bold" onClick={closeModal}>
                                    <img
                                        src={iconpath + "icon_close.png"}
                                        alt={"icon_close"}
                                        width={24}
                                        height={24}
                                        style={{ width: "100%", height: "100%" }}
                                        className="cursor-pointer"
                                    />
                                </button>
                                <picture>
                                    <source
                                        srcSet={`${selectedImage}_resize.avif`}
                                        type="image/avif"
                                        media="(max-width: 1023px)"
                                    />
                                    <source
                                        srcSet={`${selectedImage}_resize.webp`}
                                        type="image/webp"
                                        media="(max-width: 1023px)"
                                    />
                                    <source srcSet={`${selectedImage}.avif`} type="image/avif" />
                                    <source srcSet={`${selectedImage}.webp`} type="image/webp" />

                                    <img
                                        src={`${selectedImage}.webp`}
                                        alt="Large view"
                                        width={512}
                                        height={512}
                                        className="h-full w-full object-contain"
                                        loading="lazy"
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </picture>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ProductHeaderInfo;
